<template>
  <v-app id="inspire">
    <v-container class="fill-height white lighten-2">
      <v-row
        justify="center"
        no-gutters
        align="center"
      >
        <v-col
          cols="12"
          sm="6"
          md="6"
        >
          <v-card
            color="white lighten-4"
            max-width="650"
            rounded
            min-height="650"
            max-height="650"
            class="rounded-tl-xl"
            style="overflow: auto"
          >
            <v-toolbar
              color="green lighten-1"
              dark
              elevation="0"
            >
              <v-toolbar-title
                class="font-weight-bold"
                style="font-size: 15px"
              >
                BOOKING DETAIL
              </v-toolbar-title>
              <v-spacer />
              <v-btn
                outlined
                dark
                @click="cancelBooking"
              >
                <v-icon>mdi-delete</v-icon>
                DELETE THIS BOOKING
              </v-btn>
            </v-toolbar>
            <v-card-text class="ma-0 pa-10">
              <v-list>
                <v-list-item class="px-0">
                  <v-list-item-icon class="pa-0 mr-4">
                    <v-icon color="success">
                      mdi-map-marker
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>From <b class="success--text"> {{ getOriginName(getBookData.start_geofence_id) }} </b> to <b class="success--text"> {{ getDestinationAddrs(getBookData) }} </b></v-list-item-title>
                    <v-list-item-title class="mt-4">
                      <v-btn
                        color="green"
                        dark
                        outlined
                        dense
                        v-if="show"
                        @click="showMaping"
                      >
                        SHOW MAP
                      </v-btn>
                      <v-btn
                        color="green"
                        dark
                        outlined
                        dense
                        v-if="!show"
                        @click="hideMaping"
                      >
                        HIDE MAP
                      </v-btn>
                    </v-list-item-title>
                    <v-list-item-title
                      v-show="showmap"
                      class="mt-2"
                    >
                      <GmapMap
                        :style="map.style"
                        ref="gmap"
                        :center="map.center"
                        :zoom="map.zoom"
                        :options="map.options"
                      >
                        <GmapMarker
                          :position="map.oriPosition"
                          :clickable="true"
                          label="A"
                          :draggable="true"
                        />
                        <GmapMarker
                          :position="map.destPosition"
                          label="B"
                          :clickable="true"
                          :draggable="true"
                        />
                      </GmapMap>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-icon class="pa-0 mr-4">
                    <v-icon color="success">
                      mdi-calendar
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="mx-0">
                    <v-list-item-title>{{ getDate(getBookData) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-icon class="pa-0 mr-4">
                    <v-icon color="success">
                      mdi-clock-time-four-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="mx-0">
                    <v-list-item-title>{{ getMinute(getBookData) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-icon class="pa-0 mr-4">
                    <v-icon color="success">
                      mdi-car
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title v-if="getBookData.vehicle_id">
                      Pool Vehicle
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-icon class="pa-0 mr-4">
                    <v-icon color="success">
                      mdi-car-side
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content class="mx-0">
                    <v-list-item-title>{{ getVehicleType(getBookData.vehicle_id) }}</v-list-item-title>
                    <v-list-item-subtitle>{{ getVehType(getBookData.vehicle_id) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-icon class="pa-0 mr-4">
                    <v-icon color="success">
                      mdi-parking
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content class="mx-0">
                    <v-list-item-title>Parking location at <b class="success--text">{{ getVehicleParking(getBookData.vehicle_id) }} </b></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-icon class="pa-0 mr-4">
                    <v-icon color="success">
                      mdi-account-multiple
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content class="mx-0">
                    <v-list-item-title>
                      {{ getPassenger(getBookData) }} Passenger
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="6"
        >
          <v-card
            color="white lighten-4"
            max-height="650"
            rounded
            class="rounded-tr-xl rounded-br-xl"
            min-height="500"
          >
            <v-toolbar
              color="green lighten-1"
              dark
              elevation="0"
            >
              <v-toolbar-title
                class="font-weight-bold"
                style="font-size: 15px"
              >
                CALENDAR VIEW
              </v-toolbar-title>
              <v-spacer />
              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-sheet
                max-height="650"
              >
                <v-calendar
                  style="height:554px"
                  ref="calendar"
                  v-model="today"
                  color="primary"
                  :events="events"
                  type="category"
                  :category-days="categoryDays"
                  :category-show-all="categoryShowAll"
                  :category-hide-dynamic="categoryHideDynamic"
                  :event-color="getEventColor"
                  :event-ripple="false"
                  :categories="categories"
                  @change="getEvents"
                  @click:event="showEvent"
                  @mousedown:event="startDrag"
                  @mousedown:time="startTime"
                  @mousemove:time="mouseMove"
                  @mouseup:time="endDrag"
                  @mouseleave.native="cancelDrag"
                >
                  <template #event="{ event, timed, eventSummary }">
                    <div
                      class="v-event-draggable"
                      v-html="eventSummary()"
                    />
                    <div
                      v-if="timed"
                      class="v-event-drag-bottom"
                      @mousedown.stop="extendBottom(event)"
                    />
                  </template>
                  <template #category="{ category }">
                    <div
                      class="text-center pa-1"
                      style="font-size:12px;"
                    >
                      <span> {{ getCategoryNames(category)[0] }} </span>
                      <br>
                      <span> {{
                        `${getCategoryNames(category)[1]} ${
                          getCategoryNames(category)[2]
                        }`
                      }}
                      </span>
                    </div>
                  </template>
                </v-calendar>
                <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  offset-x
                  class="ma-5"
                >
                  <v-card
                    color="white lighten-4"
                    flat
                    max-width="550"
                  >
                    <v-toolbar
                      color="grey lighten-3"
                      dense
                      elevation="0"
                      max-width="550"
                    >
                      <v-toolbar-title v-html="selectedEvent.name" />
                      <v-spacer />
                      <v-btn icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text class="ma-0">
                      <v-list>
                        <v-list-item class="px-0">
                          <v-list-item-icon class="pa-0 mr-4">
                            <v-icon
                              color="indigo"
                              dense
                            >
                              mdi-clock-time-four-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-content class="mx-0">
                            <v-list-item-title style="font-size: 14px; font-weight: 400;">
                              From
                            </v-list-item-title>
                            <v-list-item-subtitle>{{ getMinute(getBookData) }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="px-0">
                          <v-list-item-icon class="pa-0 mr-4">
                            <v-icon
                              color="indigo"
                              dense
                            >
                              mdi-clock-time-four-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-content class="mx-0">
                            <v-list-item-title style="font-size: 14px; font-weight: 400;">
                              To
                            </v-list-item-title>
                            <v-list-item-subtitle>{{ start_time }} - {{ end_time }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        text
                        color="secondary"
                        @click="selectedOpen = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="editItem"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-sheet>
            </v-card-text>
          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="secondary"
              @click="selectedOpen = false"
            >
              Cancel
            </v-btn>
              <v-btn
              text
              color="primary"
            >
              Save
            </v-btn>
          </v-card-actions> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import moment from "moment";
import isUndefined from "lodash/isUndefined";



export default {
  data: () => ({
    start_date: '',
    end_date: '',
    categories: [],
    categoryShowAll: true,
    categoryHideDynamic: false,
    categoryDays: 1,
    dragEvent: null,
    events: [],
    createEvent: null,
    createStart: null,
    extendOriginal: null,
    startCalendar: '',
    show: true,
    today: '',
    token: "",
    clientid: "",
    getBookData: [],
    showmap: false,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    start_time: '',
    end_time: '',
    map: {
      style: "width: 100; height: 400px",
      center: {},
      zoom: 4,
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      marker: {},
      oriId: "",
      oriPosition: {},
      destId: "",
      destPosition: {},
    },
  }),
  created() {
    this.$store.dispatch("LOAD_POOL_DATA");
    this.$store.dispatch("LOAD_DESTINATION_DATA");
    this.$store.dispatch("GET_GEOFENCES");
    this.$store.dispatch("LOAD_VEHICLE_TYPES");


    this.getData()
  },
  computed: {
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
    getVehicles() {
      return this.$store.getters["getVehicles"];
    },
    googles: gmapApi,
    getPoolData() {
      return this.$store.getters.getPoolData;
    },
    getDestinationData() {
      return this.$store.getters.getDestinationData;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getOrigin() {
      if (this.geofences[this.$store.state.clientid]) {
        const groups = this.geofences[this.$store.state.clientid].filter(
          (group) =>
            group.name === "Carpool Origin" ||
            group.name === "Carpool Origin - Destination"
        );
        const geofences = [];

        // eslint-disable-next-line no-unused-vars
        groups.forEach((group, i) => {
          // eslint-disable-next-line no-unused-vars
          group.geofences.forEach((geofence, i) => {
            geofences.push(geofence);
          });
        });
        // eslint-disable-next-line no-console
        return geofences;
      }
    },
  },
  methods: {
    cancelBooking() {
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        showCancelButton: true,
        confirmButtonText: "Yes, Cancel this Booking!",
        cancelButtonText: "No, Keep it!",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('API_CALL', {
            $method: 'delete_book',
            $postData: {
              book_id: this.getBookData.id,
            },
          });
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Success Delete Booking",
          });
          this.$router.push({ path: "/my_booking" });
        }
      });
    },
    editItem() {
      this.$swal({
        title:
          '<span style="color:#FFFFFF;">Update Booking</span>',
        html:
          '<span style="color:#FFFFFF;font-size: 1.3rem;font-weight: 700;letter-spacing: 0.0125em;">Are you sure want to Update this booking?</span>',
        showCancelButton: true,
        confirmButtonText:
          '<span style="color:#FFFFFF;font-weight: 700;letter-spacing: 0.0892857143em;">YES</span>',
        cancelButtonText:
          '<span style="color:#FFFFFF;font-weight: 700;letter-spacing: 0.0892857143em;">NO</span>',
        background: "#4CAF50",
        confirmButtonColor: "#4CAF50",
        cancelButtonColor: "#4CAF50",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          let data = "";
          const start = `${moment(this.start_date).format("YYYY-MM-DD")} ${this.start_time}`;
          const end = `${moment(this.end_date).format("YYYY-MM-DD")} ${this.end_time}`;
          data = {
            id: this.getBookData.id,
            start_datetime: start,
            end_datetime: end,
          };
          this.$store.dispatch('API_CALL', {
            $method: 'update_book',
            $postData: {
              data: data
            },
          }).then(
            (response) => {
              if (response !== null) {
                this.selectedOpen = false
                this.$store.dispatch('API_CALL', {
                  $method: 'get_book_by_id',
                  $postData: {
                    id: this.getBookData.id
                  },
                }).then((response) => {
                  this.getBookData = response.data.data
                })
              }

              if(response.data.code == 200) {
                this.$swal({
                  icon: 'success',
                  title: response.data.data.message,
                  text: 'Your booking time succesfully updated',
                })
                this.$router.push({ path: "/my_booking" });
              } else {
                this.$swal({
                  icon: 'error',
                  title: response.data.data.message,
                })
              }
            })
        }
      });
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event

        this.selectedElement = nativeEvent.target

        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    startDrag ({ event, timed }) {
      if (event && timed) {
        this.dragEvent = event
        this.dragTime = null
        this.extendOriginal = null
      }
    },
    startTime (tms) {
      const mouse = this.toTime(tms)

      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start

        this.dragTime = mouse - start
      } else {
        this.createStart = this.roundTime(mouse)
      }
    },
    extendBottom (event) {
      this.createEvent = event
      this.createStart = event.start
      this.extendOriginal = event.end
    },
    mouseMove (tms) {
      const mouse = this.toTime(tms)

      if (this.dragEvent && this.dragTime !== null) {
        const start = this.dragEvent.start
        const end = this.dragEvent.end
        const duration = end - start
        const newStartTime = mouse - this.dragTime
        const newStart = this.roundTime(newStartTime)
        const newEnd = newStart + duration
        const mouseRounded = this.roundTime(newStart, false);
        const min = Math.min(mouseRounded, newStart);
        const max = Math.max(mouseRounded, newEnd);
        this.start_time = moment(min).format("HH:mm");
        this.end_time = moment(max).format("HH:mm");
        this.dragEvent.start = newStart
        this.dragEvent.end = newEnd
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStart)
        const max = Math.max(mouseRounded, this.createStart)
        this.start_time = moment(min).format("HH:mm");
        this.end_time = moment(max).format("HH:mm");

        this.createEvent.start = min
        this.createEvent.end = max
      }
    },
    endDrag () {
      this.dragTime = null
      this.dragEvent = null
      this.createEvent = null
      this.createStart = null
      this.extendOriginal = null
    },
    cancelDrag () {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal
        } else {
          const i = this.events.indexOf(this.createEvent)
          if (i !== -1) {
            this.events.splice(i, 1)
          }
        }
      }

      this.createEvent = null
      this.createStart = null
      this.dragTime = null
      this.dragEvent = null
    },
    roundTime (time, down = true) {
      const roundTo = 15
      const roundDownTime = roundTo * 60 * 1000

      return down
        ? time - time % roundDownTime
        : time + (roundDownTime - (time % roundDownTime))
    },
    toTime (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
    getEventColor (event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.dragEvent
        ? `rgba(${r}, ${g}, ${b}, 0.7)`
        : event === this.createEvent
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event.color
    },
    getEvents () {
      const startdate = moment(this.getBookData.start_datetime).format("YYYY-MM-DD hh:mm:ss");
      const endDate = moment(this.getBookData.end_datetime).format("YYYY-MM-DD hh:mm:ss");

      const events = [
        {
          category: this.getBookData.vehicle_id,
          color: "green",
          name: "Update Booking Time",
          start: new Date(startdate).getTime(),
          end: new Date(endDate).getTime(),
          timed: true,
          id: this.getBookData.id
        },
      ]

      this.events = events
    },
    showMaping() {
      this.show = false
      this.showmap = true
    },
    hideMaping() {
      this.showmap = false
      this.show = true
    },
    getOriginName(originId) {
      if (originId == null) return;
      const origin = this.getPoolData.find(
        (o) => o.Id == originId
      );
      if (!origin) return;
      return origin.name;
    },
    getCategoryNames(id) {
      const status = this.getVehicles.find(
        (vehicle) => vehicle.vehicle_id === id
      );
      if (status) {
      return [
        status.device_name,
        status.device_make,
        status.device_model.replace(/[^\w\s]/gi, ""),
      ];
      } else {return}
    },
    getDate(date) {
      if (date == null) return;
      const start = moment(date.start_datetime, "YYYY-MM-DD");
      const end = moment(date.end_datetime, "YYYY-MM-DD");
      this.start_date = start
      this.end_date = end
      if (start == moment().format("YYYY-MM-DD")) {
        return "Today";
      } else {
        return `${start.format('dddd, MMMM Do YYYY')}`;
      }
    },
     getMinute(date) {
      if (date == null) return;
      const start = moment(date.start_datetime, "YYYY-MM-DD hh:mm");
      const end = moment(date.end_datetime, "YYYY-MM-DD hh:mm");
      return `${moment(start).format('hh:mm')} - ${moment(end).format('hh:mm')}`;
    },
    getVehType(id) {
      let showDesc = this.getVehicles.find(
        (vehicle) => vehicle.vehicle_id === id
      );
      let vehDesc = "";
      if(showDesc){
        vehDesc = `${showDesc.device_make.replace(/[^\w\s]/gi, "")} ${showDesc.device_model.replace(/[^\w\s]/gi, "")} ${showDesc.device_name.replace(/[^\w\s]/gi, "")}`;
      }
      return vehDesc
    },
     getVehicleType(id) {

      let showDesc = this.getVehicles.find(
        (vehicle) => vehicle.vehicle_id === id
      );
      let vehDesc = "";
      if(showDesc){
        vehDesc = showDesc.type_name
      }
      return vehDesc
    },
    getVehicleParking(id) {

      let showDesc = this.getVehicles.find(
        (vehicle) => vehicle.vehicle_id === id
      );
      if(!showDesc) return;
      let vehDesc = "";
      if(showDesc.hasOwnProperty("metadata")){
        vehDesc = showDesc.metadata.parking_location
      }
      return vehDesc
    },
    getPassenger(data) {
      if (!data.book_user) return "-";
      return data.book_user.passenger_count
    },
    getDestinationAddrs(getBookData) {
      if (getBookData == null) return;
      let metadata = "";
      if (getBookData.hasOwnProperty("metadata")) {
        metadata = getBookData.metadata;
        if (metadata == "[]") {
          const metadata = this.getDestinationData.find(
            (g) => g.Id == getBookData.end_geofence_id
          );
          if (!metadata) return;
          return metadata.name;
        } else {
          const metadata = JSON.parse(getBookData.metadata);
          return metadata.address;
        }
      } else if (getBookData.end_geofence_id != 0) {
        const geofenceDestination = this.getDestinationData.find(
          (geofence) =>
            parseInt(geofence.Id) === parseInt(getBookData.end_geofence_id)
        );
        if (!isUndefined(geofenceDestination)) {
          let destination = geofenceDestination.name;
          return destination;
        }
      }
    },
    getData() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      const { book_id } = this.$route.params;
      this.$store.dispatch('API_CALL', {
          $method: 'get_book_by_id',
          $postData: {
            id: book_id
          },
        })
        .then((response) => {
          this.getBookData = response.data.data
          this.startCalendar = new Date();
          this.categories.push(this.getBookData.vehicle_id)
          this.today = new Date(moment(this.getBookData.start_datetime));
          this.$refs.calendar.scrollToTime(moment(this.getBookData.start_datetime).format('hh:mm'));
          const geo = this.getOrigin.find((origin) => origin.Id == this.getBookData.start_geofence_id);
          if (!geo) return;
          // Map Start
          const latOri = (parseFloat(geo.top) + parseFloat(geo.bottom)) / 2;
          const lngOri = (parseFloat(geo.left) + parseFloat(geo.right)) / 2;
          this.map.oriId = geo.Id;
          this.map.oriPosition = {
            "lat" : latOri,
            "lng" : lngOri,
          };
          const lat2 = parseFloat(this.map.oriPosition.lat);

          const lat = parseFloat(this.getBookData.end_latitude);
          const lng = parseFloat(this.getBookData.end_longitude);
          this.map.destPosition = { lat, lng };
          this.map.center = { lat2, lng };
          let bounds = new this.googles.maps.LatLngBounds()
          var locations = [
            [this.map.oriPosition.lat, this.map.oriPosition.lng],
            [this.map.destPosition.lat, this.map.destPosition.lng],
          ];
          for (var i = 0; i < locations.length; i++) {
            var beach = locations[i];
            let myLatLng = new this.googles.maps.LatLng(
              beach[0],
              beach[1]
            );
            bounds.extend(myLatLng);
          }
          this.$refs.gmap.fitBounds(bounds);
          this.map.zoom = 5;
        });
    },
  },
};
</script>
<style lang="scss">
  .v-event-draggable {
    padding-left: 6px;
  }

  .v-event-timed {
    user-select: none;
    -webkit-user-select: none;
  }

  .v-event-drag-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 4px;
    height: 4px;
    cursor: ns-resize;

    &::after {
      display: none;
      position: absolute;
      left: 50%;
      height: 4px;
      border-top: 1px solid white;
      border-bottom: 1px solid white;
      width: 16px;
      margin-left: -8px;
      opacity: 0.8;
      content: '';
    }

    &:hover::after {
      display: block;
    }
}
</style>
